// @flow

import React from 'react';
import { toastr } from 'react-redux-toastr';

import styles from './deactivateOaModal.scss';
import Modal from '../modal/modal';

type Props = {
  title?: string,
  oaModal: Object,
  showDeactivateOaModal: boolean,
  closeDeactivateOaModalAction: Function,
  text: string,
  deactivateOaAction: Function,
  deactivateOaModalState: Object
};

const deleteIcon = require('../../../assets/images/delete.svg');

class DeactivateOaModal extends React.Component<Props> {
  // noinspection JSCheckFunctionSignatures
  componentDidUpdate(prevProps: Object): void {
    const { deactivateOaModalState } = this.props;
    if (deactivateOaModalState.deactivateOa.isLoading) {
      return;
    }
    this.handleCloseDialogAndRefreshTab(prevProps, this.props);
    this.showToast(prevProps, this.props);
  }

  handleCloseDialogAndRefreshTab(prevProps, currProps) {
    if (
      prevProps.showDeactivateOaModal !== currProps.showDeactivateOaModal &&
      !currProps.showDeactivateOaModal
    ) {
      if (currProps.deactivateOaModalState.deactivateOa.refreshTab) {
        currProps.closeDeactivateOaModalAction({ refreshTab: true });
      } else {
        currProps.closeDeactivateOaModalAction({ refreshTab: false });
      }
    }
  }

  showToast(prevProps, currProps) {
    if (
      prevProps.deactivateOaModalState.deactivateOa !==
      currProps.deactivateOaModalState.deactivateOa
    ) {
      const {
        status,
        val
      } = currProps.deactivateOaModalState.deactivateOa.data;
      if (status === 'success') {
        toastr.success('Success', 'Deactivated OA successful');
      } else if (status === 'error' || status === 'exception') {
        toastr.error('Error', val || 'Deactivate OA failed');
      }
    }
  }

  handleOnDeactivate() {
    const { deactivateOaAction, oaModal } = this.props;
    deactivateOaAction(oaModal);
  }

  render() {
    const {
      deactivateOaModalState,
      showDeactivateOaModal,
      title,
      oaModal,
      closeDeactivateOaModalAction,
      text
    } = this.props;
    return (
      <Modal
        showLoader={deactivateOaModalState.deactivateOa.isLoading}
        showModal={showDeactivateOaModal}
        title={`${title} ${oaModal ? `( ${oaModal.name} )` : ''}`}
        closeModal={() => {
          closeDeactivateOaModalAction({ refreshTab: false });
        }}
      >
        {oaModal ? (
          <div className={styles.deactivateOaModalWrapper}>
            <div className=" l-row j-center a-center">
              <img src={deleteIcon} alt="Loading..." />
            </div>
            <div className={styles.deleteText}>
              {text
                .replace('#oaName', oaModal.name)
                .replace('#oaMobile', oaModal.mobileNo)}
            </div>
            <div className={`${styles.footerSection} l-row j-end a-center`}>
              <div
                className={`${styles.cancelBtnWrapper} l-row j-center a-center`}
                onClick={() => {
                  closeDeactivateOaModalAction({ refreshTab: false });
                }}
              >
                CANCEL
              </div>
              <div
                onClick={() => this.handleOnDeactivate()}
                className={`${styles.deleteBtnWrapper} l-row j-center a-center`}
              >
                DEACTIVATE
              </div>
            </div>
          </div>
        ) : null}
      </Modal>
    );
  }
}

DeactivateOaModal.defaultProps = {
  title: 'Deactivate',
  showDeactivateOaModal: false
};

export default DeactivateOaModal;
